/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { WINDOW_ICON, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { ILanding } from "../../data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "../../data/store"
import { getLandingContainer } from "../utils/getLandingContainer"
import LandingContainer from "./LandingContainer"
import { ILandingSnapshotProps } from "./LandingSnapshotForm"
import Section from "./section/Section"
import SectionContainer from "./section/SectionContainer"
import ToUp from "./section/ToUp"
import LandingOverlay from "./landing-overlay/LandingOverlay"
import { __ } from "src/libs/utilities"
 
const LandingSnapshot = (props: ILandingSnapshotProps): JSX.Element => { 
    const currentLanding:ILanding   = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const currentDimensionEdit      = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    useEffect(() => {  
        const resizeObserver = new ResizeObserver((entries, observer) => {
            entries.forEach((entry) => {
                useLandingStore.setState({landingRect: entry.contentRect})  
            });
        });
        const landingContainer = getLandingContainer()
        if(landingContainer) {
            resizeObserver.observe( landingContainer ) 
        }
        return () => { 
            resizeObserver.unobserve( landingContainer )
        }
     }, [])
    useEffect(() => {  
         const landingContainer = getLandingContainer() as HTMLDivElement
         if(!landingContainer) {
            return 
         }
         const landingBg: any = document.querySelector(".landing-background.main-landing") as HTMLDivElement
         if(currentDimensionEdit < WINDOW_WIDTH.PANEL) { 
             landingContainer.style.width = currentDimensionEdit + "px"
             landingBg.style.width = currentDimensionEdit + "px"
             landingBg.style.margin = "0 auto"
             landingBg.style.border = "1px dotted var(--force-contast-color)"
         }
         else {
             landingContainer.style.width = "100%"
             landingBg.style.width = "100%"
             delete landingBg.style.margin 
             delete landingBg.style.border 
         }
     }, [ currentDimensionEdit ]) 
    return !!currentLanding.sections
        ?
        <>
            <LandingContainer isEdit={false}>
                <>
                    {
                        !!currentLanding.sections.length
                            ?
                            currentLanding.sections
                                .map((section, i) => {
                                    return section?.id 
                                    ?
                                    <SectionContainer i={i} section={section} key={section.id} >
                                        {
                                            !section.isHidden 
                                                ?
                                                <Section i={i} section={section} />
                                                :
                                                <></>
                                        }
                                    </SectionContainer>
                                    :
                                    <></>
                                })
                            :
                            <div className="layout-app-state flex-centered">
                                <div className="container">
                                    <CalloutNoExists message="Page is empty" > 
                                    </CalloutNoExists>
                                </div>
                            </div>
                    }
                    <ToUp data={currentLanding.toUp} />
                </>
            </LandingContainer> 
            <LandingOverlay />
            {/* { props.isAuthor && <Hotkeys /> }  */}
        </>
        :
        <div className="layout-app-state d-flex flex-centered p-5">
            <CalloutNoExists message={__("Error load data")} />
        </div>
}
export default LandingSnapshot

const Hotkeys = (): JSX.Element => {
    const onKeyPress = ( evt: KeyboardEvent ) => {
        if( evt.shiftKey && evt.code === "KeyV" ) {
            console.log( "Preview", evt)
            useLandingConsoleStore.setState({ isEdit: true })
        }
        if( evt.ctrlKey ) {
            (Object.keys(WINDOW_WIDTH) as (keyof typeof WINDOW_ICON)[])
                .filter((sz: keyof typeof WINDOW_ICON ) => {
                    return !!WINDOW_ICON[ sz ]
                })
                .forEach((sz: keyof typeof WINDOW_ICON, i ) => { 
                    if( evt.key === i.toString() ) {
                        useLandingConsoleStore.setState({ currentDimensionEdit: WINDOW_WIDTH[ sz ] })
                    }
                })
        }
        evt.stopPropagation()
        evt.preventDefault()
    }
    useEffect(() => { 
        document.addEventListener("keydown", onKeyPress)

        return () => {
            document.removeEventListener("keydown", onKeyPress)
        }
    }, [])
    return <div className='position-absolute top left'>
        
    </div>
}